// import React, { useState } from "react";
// import axios from "axios";
// import { useGuardStore } from "../context/GuardContext";
// import { toast } from "react-toastify";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export default function GuardIncident() {
//   const { selectedGuard } = useGuardStore();

//   const [ariseOption] = useState("Arise");
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);

//   const token = localStorage.getItem("guardToken");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!message) {
//       toast.error("Please enter incident message");
//       return;
//     }

//     if (!selectedGuard) {
//       toast.error("No Guard Selected");
//       return;
//     }

//     const payload = {
//       guardData: selectedGuard,
//       req: ariseOption,
//       message: message,
//     };

//     try {
//       setLoading(true);

//       await axios.post(`${BASE_URL}/api/duty/accident`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       toast.success("Incident Request Sent Successfully ");
//       setMessage("");
//     } catch (error) {
//       console.error("Incident Error:", error);
//       toast.error("Failed to send incident request ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.pageContainer}>
//       {/* ---------- HEADER ---------- */}
//       <div style={styles.header}>
//         <h2 style={styles.headerTitle}>
//           <i className="fa fa-exclamation-triangle me-2"></i> Guard Incident
//         </h2>
//         <p style={styles.headerSubtitle}>
//           Report any emergency or on-duty incident
//         </p>
//       </div>

//       {/* ---------- CARD ---------- */}
//       <div style={styles.card}>
//         <div style={styles.cardBody}>
//           <div style={styles.profileRow}>
//             {/* -------- LEFT SECTION (INSTRUCTIONS) -------- */}
//             <div style={styles.leftBox}>
//               <h4 style={styles.pointsTitle}>When to Raise Incident?</h4>

//               <ul style={styles.pointList}>
//                 <li>🚨 Accident during duty</li>
//                 <li>⚠️ Threat from any person</li>
//                 <li>🛑 VIP in danger</li>
//                 <li>🚑 Medical emergency</li>
//                 <li>🔥 Fire or violence</li>
//                 <li>📞 Any urgent security issue</li>
//               </ul>

//               <div style={styles.noteBox}>
//                 ⚠️ Only use <b>ARISE</b> for real emergency situations.
//               </div>
//             </div>

//             {/* -------- RIGHT SECTION (FORM) -------- */}
//             <div style={styles.rightBox}>
//               {/* --- Guard Details --- */}
//               {selectedGuard && (
//                 <>
//                   {[
//                     ["Name", selectedGuard.name],
//                     ["Contact No", selectedGuard.contactno],
//                     ["Email", selectedGuard.email],
//                     ["Incident Type", "ARISE"],
//                   ].map(([label, value], i) => (
//                     <div style={styles.detailRow} key={i}>
//                       <div style={styles.detailLabel}>{label}:</div>
//                       <div style={styles.detailValue}>{value}</div>
//                     </div>
//                   ))}
//                 </>
//               )}

//               {/* -------- INCIDENT FORM -------- */}
//               <form onSubmit={handleSubmit} style={{ marginTop: "25px" }}>
//                 {/* ARISE BUTTON */}
//                 <div className="mb-3 text-center">
//                   <button
//                     type="button"
//                     style={{
//                       ...styles.ariseBtn,
//                       opacity: 0.8,
//                       cursor: "not-allowed",
//                     }}
//                     disabled
//                   >
//                     ARISE
//                   </button>
//                 </div>

//                 {/* MESSAGE */}
//                 <div className="mb-3">
//                   <textarea
//                     className="form-control"
//                     rows="4"
//                     placeholder="Enter incident details..."
//                     value={message}
//                     onChange={(e) => setMessage(e.target.value)}
//                     style={styles.textarea}
//                   ></textarea>
//                 </div>

//                 {/* SUBMIT */}
//                 <button
//                   type="submit"
//                   style={{
//                     ...styles.submitBtn,
//                     opacity: loading ? 0.6 : 1,
//                   }}
//                   disabled={loading}
//                 >
//                   {loading ? "Sending..." : "Submit Incident"}
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ------------------ RESPONSIVE GLASS UI THEME ------------------ */
// const styles = {
//   pageContainer: {
//     padding: "30px",
//     minHeight: "100vh",
//     background: "rgba(255,255,255,0.15)",
//     backdropFilter: "blur(6px)",
//   },
//   header: {
//     marginBottom: "25px",
//     padding: "20px",
//     background: "linear-gradient(135deg, #ff9966, #ff5e62)",
//     borderRadius: "14px",
//     color: "white",
//     boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
//   },
//   headerTitle: { margin: 0, fontSize: "26px", fontWeight: "700" },
//   headerSubtitle: { marginTop: "5px", opacity: 0.9 },

//   card: {
//     background: "rgba(255,255,255,0.55)",
//     borderRadius: "18px",
//     padding: "25px",
//     backdropFilter: "blur(8px)",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//   },

//   profileRow: {
//     display: "flex",
//     gap: "40px",
//     flexWrap: "wrap",
//     alignItems: "flex-start",
//   },

//   leftBox: {
//     flex: "1",
//     padding: "20px",
//     borderRadius: "12px",
//     background: "rgba(255,255,255,0.7)",
//   },

//   pointsTitle: {
//     fontSize: "20px",
//     fontWeight: "700",
//     marginBottom: "15px",
//   },

//   pointList: {
//     paddingLeft: "18px",
//     fontSize: "15px",
//     lineHeight: "1.8",
//     fontWeight: "500",
//   },

//   noteBox: {
//     marginTop: "15px",
//     padding: "10px",
//     background: "#fff3cd",
//     borderRadius: "8px",
//     fontSize: "14px",
//     fontWeight: "600",
//   },

//   rightBox: { flex: "2" },

//   detailRow: {
//     display: "flex",
//     marginBottom: "12px",
//     flexWrap: "wrap",
//   },
//   detailLabel: { width: "150px", fontWeight: "600", color: "#333" },
//   detailValue: { flex: 1, fontWeight: "500", color: "#444" },

//   ariseBtn: {
//     background: "#ffc107",
//     color: "#000",
//     padding: "10px 40px",
//     borderRadius: "25px",
//     border: "none",
//     fontWeight: "700",
//   },

//   textarea: {
//     borderRadius: "10px",
//     border: "1px solid #ccc",
//     padding: "10px",
//   },

//   submitBtn: {
//     width: "100%",
//     background: "#ff5e62",
//     color: "white",
//     padding: "12px",
//     borderRadius: "12px",
//     border: "none",
//     cursor: "pointer",
//     fontWeight: "600",
//   },
// };

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useGuardStore } from "../context/GuardContext";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function GuardIncident() {
  const navigate = useNavigate();
  const { selectedGuard } = useGuardStore();

  const [ariseOption] = useState("Arise");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [hasDuty, setHasDuty] = useState(false);
  const [checkingDuty, setCheckingDuty] = useState(true);

  const token = localStorage.getItem("guardToken");

  /* ================= CHECK DUTY FIRST ================= */
  useEffect(() => {
    const checkDuty = async () => {
      if (!selectedGuard?.id) {
        navigate("/guardshift");
        return;
      }

      try {
        const res = await axios.get(
          `${BASE_URL}/api/assignments/getvip/${selectedGuard.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const duty =
          res.data?.data || res.data?.vip || res.data || null;

        if (!duty) {
          toast.error("No active duty assigned");
          navigate("/guardshift");
          return;
        }

        setHasDuty(true);
      } catch (error) {
        console.error("Duty check failed:", error);
        toast.error("Unable to verify duty");
        navigate("/guardshift");
      } finally {
        setCheckingDuty(false);
      }
    };

    checkDuty();
  }, [selectedGuard, navigate, token]);

  /* ================= LOADING WHILE CHECKING ================= */
  if (checkingDuty) {
    return (
      <div className="text-center py-5">
        <i className="fa fa-spinner fa-spin fa-2x text-primary mb-3"></i>
        <h5>Checking duty status...</h5>
      </div>
    );
  }

  if (!hasDuty) return null;

  /* ================= SUBMIT INCIDENT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message) {
      toast.error("Please enter incident message");
      return;
    }

    const payload = {
      guardData: selectedGuard,
      req: ariseOption,
      message,
    };

    try {
      setLoading(true);

      await axios.post(`${BASE_URL}/api/duty/accident`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      toast.success("Incident Request Sent Successfully");
      setMessage("");
    } catch (error) {
      console.error("Incident Error:", error);
      toast.error("Failed to send incident request ❌");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h2 style={styles.headerTitle}>
          <i className="fa fa-exclamation-triangle me-2"></i> Officer Incident
        </h2>
        <p style={styles.headerSubtitle}>
          Report any emergency or on-duty incident
        </p>
      </div>

      <div style={styles.card}>
        <div style={styles.profileRow}>
          {/* LEFT INFO */}
          <div style={styles.leftBox}>
            <h4 style={styles.pointsTitle}>When to Raise Incident?</h4>
            <ul style={styles.pointList}>
              <li>🚨 Accident during duty</li>
              <li>⚠️ Threat from any person</li>
              <li>🛑 VIP in danger</li>
              <li>🚑 Medical emergency</li>
              <li>🔥 Fire or violence</li>
              <li>📞 Any urgent security issue</li>
            </ul>

            <div style={styles.noteBox}>
              ⚠️ Use <b>ARISE</b> only for real emergencies
            </div>
          </div>

          {/* RIGHT FORM */}
          <div style={styles.rightBox}>
            {selectedGuard && (
              <>
                {[
                  ["Name", selectedGuard.name],
                  ["Contact No", selectedGuard.contactno],
                  ["Email", selectedGuard.email],
                  ["Incident Type", "ARISE"],
                ].map(([label, value], i) => (
                  <div style={styles.detailRow} key={i}>
                    <div style={styles.detailLabel}>{label}:</div>
                    <div style={styles.detailValue}>{value}</div>
                  </div>
                ))}
              </>
            )}

            <form onSubmit={handleSubmit} style={{ marginTop: "25px" }}>
              <div className="mb-3 text-center">
                <button
                  type="button"
                  style={{
                    ...styles.ariseBtn,
                    opacity: 0.8,
                    cursor: "not-allowed",
                  }}
                  disabled
                >
                  ARISE
                </button>
              </div>

              <div className="mb-3">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter incident details..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  style={styles.textarea}
                />
              </div>

              <button
                type="submit"
                style={{
                  ...styles.submitBtn,
                  opacity: loading ? 0.6 : 1,
                }}
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit Incident"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */
const styles = {
  pageContainer: {
    padding: "30px",
    minHeight: "100vh",
    background: "rgba(255,255,255,0.15)",
    backdropFilter: "blur(6px)",
  },
  header: {
    marginBottom: "25px",
    padding: "20px",
    background: "linear-gradient(135deg, #ff9966, #ff5e62)",
    borderRadius: "14px",
    color: "white",
  },
  headerTitle: { margin: 0, fontSize: "26px", fontWeight: "700" },
  headerSubtitle: { marginTop: "5px", opacity: 0.9 },
  card: {
    background: "rgba(255,255,255,0.55)",
    borderRadius: "18px",
    padding: "25px",
  },
  profileRow: {
    display: "flex",
    gap: "40px",
    flexWrap: "wrap",
  },
  leftBox: {
    flex: "1",
    padding: "20px",
    borderRadius: "12px",
    background: "rgba(255,255,255,0.7)",
  },
  pointsTitle: { fontSize: "20px", fontWeight: "700" },
  pointList: { paddingLeft: "18px", lineHeight: "1.8" },
  noteBox: {
    marginTop: "15px",
    padding: "10px",
    background: "#fff3cd",
    borderRadius: "8px",
  },
  rightBox: { flex: "2" },
  detailRow: { display: "flex", marginBottom: "12px" },
  detailLabel: { width: "150px", fontWeight: "600" },
  detailValue: { flex: 1 },
  ariseBtn: {
    background: "#ffc107",
    padding: "10px 40px",
    borderRadius: "25px",
    border: "none",
    fontWeight: "700",
  },
  textarea: {
    borderRadius: "10px",
    border: "1px solid #ccc",
  },
  submitBtn: {
    width: "100%",
    background: "#ff5e62",
    color: "white",
    padding: "12px",
    borderRadius: "12px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
  },
};
